<template>
<div class="charts">
		<div class="chart__info chart__inf-wrap">
			<div class="timeFrames">
			<div :class="item.frame === timeFrame ? 'timeFrames-item timeFrames-item_active' : 'timeFrames-item'" v-for="(item,index) in timeFrameMenu" :key="index" @click="setFrame(item.frame)">
				{{item.title}}</div>
			</div>
		</div>
		<div class="chart charts__body">
			<div class="chart__item chart__item--h100 echarts">
				<IEcharts
					:option="bar"
					:resizable="resize"
                    @datazoom="clickEvent($event)"
				/>
			</div>
		</div>
</div>
</template>
<script>
import IEcharts from "vue-echarts-v3/src/full.js";
import { mapGetters } from "vuex";
import axios from 'axios';
export default {
    props: {
        update: {default:true},
        updateHight: {default:true},
        updateRight: {default:true},
        height:{default:'full'},
        fullStatus:{default:false},
        symbolInst:{default:'EURUSD'},
    },
    components: {
        IEcharts,
    },
    data() {
        return {
            show:true,
            resize:true,
            symbol:'',
            upColor:'#ec0000',
            upBorderColor:'#8A0000',
            downColor:'#ff9292',
            downBorderColor:'#ff9292',
            timeFrameMenu: [
                {
                    frame:1,
                    title:'M1'
                },
                {
                    frame:5,
                    title:'M5'
                },
                {
                    frame:15,
                    title:'M15'
                },
                {
                    frame:30,
                    title:'M30'
                },
                {
                    frame:60,
                    title:'H1'
                },
                {
                    frame:240,
                    title:'H4'
                },
                {
                    frame:360,
                    title:'H6'
                },
                /*{
                    frame:1440,
                    title:'D1'
                },*/
            ],
            quote:0,
            timeFrame:1,
            data:0,
            dataX:0,
            dataY:0,
        bar: {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                }
            },
            grid: {
                left: '0%',
                right: '5%',
                bottom: '5%',
                width: "calc(100%-68px)",
                height:'90%',
            },
            xAxis: {
                type: 'category',
                data: this.dataX,
                scale: true,
                boundaryGap : true,
                splitNumber: 20,
                min: 'dataMin',
                max: 'dataMax',
                axisTick: {
                    show:true,
                },
                axisLine:{
                    onZero: false,
                    lineStyle:{
                        color:'#374b62'
                    }
                },
                splitLine: {
                    show:false
                },
                axisLabel: {
                    color:'#718DA8',
                    fontFamily:'Arimo'
                }
            },
            yAxis: {
                scale: true,
                splitArea: {
                    show: false
                },
                interval:10,
                position:'right',

                axisTick: {
                    show:true,
                },
                axisLine:{
                    lineStyle:{
                        color:'#374b62'
                    }
                },
                splitLine: {
                    show:false
                },
                axisLabel: {
                    color:'#718DA8',
                    fontFamily:'Arimo'
                }
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 50,
                    end: 100
                },
                {
                    show: true,
                    type: 'slider',
                    y: '90%',
                    start: 50,
                    end: 100,
                    backgroundColor:'#3d536b',
                    dataBackground: {
                        lineStyle: {
                            color:'#36e2ff',
                            width:1,
                            opacity:1
                        },
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 1,
                                colorStops: [
                                {
                                    offset: 0,
                                    color: "#36e2ff" // color at 0% position
                                },
                                {
                                    offset: 1,
                                    color: "rgba(0, 175, 255, 1)" // color at 100% position
                                }
                                ],
                                globalCoord: false
                            }
                        }
                    },
                    fillerColor:'rgba(47,69,84,0.7)',
                    borderColor:'#374b62',
                    textStyle:{
                        color: '#FF8585',
                    }
                }
            ],
            series: [
                {
                    name: 'EUR/USD',
                    type: 'candlestick',
                    data: this.dataY,
                    itemStyle: {
                        normal: {
                            color: '#00FFA9',
                            color0: '#FF8585',
                            borderColor: '#00FFA9',
                            borderColor0: '#FF8585'
                        }
                    },
                    markPoint: {
                        label: {
                            color:'#374b62',
                            /*normal: {
                                formatter: function (param) {
                                    return param != null ? Math.round(param.value) : '';
                                }
                            }*/
                        },
                        data: [
                            /*{
                                name: 'XX标点',
                                coord: ['2013/5/31', 2300],
                                value: 2300,
                                itemStyle: {
                                    normal: {color: 'rgb(41,60,85)'}
                                }
                            },
                            {
                                name: 'highest value',
                                type: 'max',
                                valueDim: 'highest',
                                itemStyle: {
                                    normal: {color: '#374b62'}
                                }
                            },
                            {
                                name: 'lowest value',
                                type: 'min',
                                valueDim: 'lowest',
                                itemStyle: {
                                    normal: {color: '#374b62'}
                                }
                            },
                            {
                                name: 'average value on close',
                                type: 'average',
                                valueDim: 'close',
                                itemStyle: {
                                    normal: {color: '#374b62'}
                                }
                            }*/
                        ],
                        tooltip: {
                            formatter: function (param) {
                                return param.name + '<br>' + (param.data.coord || '');
                            }
                        }
                    },
                    markLine: {
                        symbol: ['none', 'none'],
                        data: [

                            /*{
                                name: 'min line on close',
                                type: 'min',
                                valueDim: 'close'
                            },
                            {
                                name: 'max line on close',
                                type: 'max',
                                valueDim: 'close'
                            }*/
                        ]
                    }
                }
            ]
},
            signal:true
        }

    },
    computed: {
        ...mapGetters({
            quotes: "quotes/getQuotes",
         }),
        getQuote() {
             return this.quotes[this.symbolInst].bid
         }
    },
    methods : {
        updateChart() {
            if(this.data === 0)
                return
            let pointForChart = splitData(this.data);
            this.bar.series[0].data  = pointForChart.values;
            this.bar.xAxis.data = pointForChart.categoryData;
            //getPoints(pointForChart, this.bar);
        },
        getCandles() {
            axios
            .get('https://api.iqquantum.com/api/bars?ticker=' + this.symbolInst + '&timeframe=' + this.timeFrame + '&count=100')
            .then(response => {this.data = response.data;this.updateChart();});
        },
        setFrame(frame) {
            this.timeFrame = frame;
            this.getCandles();
        },
        clickEvent(e) {
            window.console.log(e);
        }
    },
    watch: {
        update: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateHight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateRight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        getQuote: function(newVal, oldVal) {
            let nowDate = new Date();
            let time = roundTime(nowDate, this.timeFrame);
            if(this.timeFrame < 60)
                if (new Date(this.bar.xAxis.data[this.bar.xAxis.data.length - 1]).getMinutes() !== new Date(time).getMinutes()) {
                    this.bar.series[0].data.push([newVal,newVal,newVal,newVal]);
                    this.bar.xAxis.data.push(time);
                    return;
                }
            if(this.timeFrame >= 60)
                if (new Date(this.bar.xAxis.data[this.bar.xAxis.data.length - 1]).getHours() !== new Date(time).getHours()) {
                    this.bar.series[0].data.push([newVal,newVal,newVal,newVal]);
                    this.bar.xAxis.data.push(time);
                    return;
                }
            this.$set(this.bar.series[0].data[this.bar.series[0].data.length-1],3, Math.max(this.bar.series[0].data[this.bar.series[0].data.length-1][3], newVal));
            this.$set(this.bar.series[0].data[this.bar.series[0].data.length-1],2, Math.min(this.bar.series[0].data[this.bar.series[0].data.length-1][2], newVal));
            this.$set(this.bar.series[0].data[this.bar.series[0].data.length-1],1, newVal);
            this.bar.series[0].markPoint.data = [];
            this.bar.series[0].markPoint.data.push(
            {
                label: {
                    show:true,
                    color:newVal < oldVal ? '#ff9292' : '#00ffd0',
                    position: 'right',
                    fontSize: 13,
                    width:'100%',
                    offset:[0,5],
                    backgroundColor:'#3d536b'
                },
                itemStyle: {
                    opacity:1,
                    color: newVal < oldVal ? '#ff9292' : '#00ffd0',
                },
                yAxis: newVal,
                xAxis: this.bar.xAxis.data.length - 1,
                value: newVal,
                symbolSize: '0px',
                symbol:'emptyCircle',
                zlevel:3
            },
            {
                label: {
                    show:true,
                    color:newVal < oldVal ? '#ff9292' : '#00ffd0',
                    position: 'right',
                    fontSize: 10,
                    width:'100%',
                    offset:[0,20],
                    backgroundColor:'#3d536b'
                },
                itemStyle: {
                    opacity:1,
                    color: newVal < oldVal ? '#ff9292' : '#00ffd0',
                },
                yAxis: newVal,
                xAxis: this.bar.xAxis.data.length - 1,
                value: (newVal - this.bar.series[0].data[this.bar.series[0].data.length - 1][0]).toFixed(5),
                symbolSize: '0px',
                symbol:'emptyCircle',
                zlevel:3
            }
        )
        },
    },
    mounted() {
       /* setInterval(() => {axios
            .get('http://138.201.252.82:5001/api/bars?ticker=EURUSD&timeframe=5&count=200')
            .then(response => (this.data = response.data));
            this.signal = !this.signal}, 15000);
        setInterval(() => {this.getCandles()
            },15000);*/

    },
    created() {
        this.getCandles();
    }
    }
    // created }

function splitData(rawData) {
    var categoryData = [];
    var values = []
    for (var i = 0; i < rawData.length; i++) {
        categoryData.push((rawData[i].timeOpen));
        values.push([rawData[i].open, rawData[i].close, rawData[i].low,rawData[i].high])
        //.split('T')[1]
    }
    return {
        categoryData: categoryData,
        values: values
    };
}

function roundTime(date, frame) {
    let now = new Date(date);
    let mins = now.getMinutes();
    let hours = now.getHours();
    let day = now.getDate();
    if(frame < 60) {
        let frameInHours = Math.floor(mins/frame);
        let rounded = (frameInHours*frame)%60;
        now.setMinutes(rounded);
    }
    if(frame === 60 || frame === 240 || frame === 360) {
        let frameInHours = Math.floor(hours/(frame/60));
        let rounded = (frameInHours*(frame/60))%24;
        now.setHours(rounded);
    }
    return now;
}

function calculateMA(dayCount) {
    var result = [];
    for (var i = 0, len = data0.values.length; i < len; i++) {
        if (i < dayCount) {
            result.push('-');
            continue;
        }
        var sum = 0;
        for (var j = 0; j < dayCount; j++) {
            sum += data0.values[i - j][1];
        }
        result.push(sum / dayCount);
    }
    return result;
}

function getPoints(data, chartObject) {
    chartObject.xAxis.data = data.categoryData;
    chartObject.series[0].data = data.values;
    chartObject.series[0].data.shift('','','','');
}


</script>
<style lang="less" scoped>

.timeFrames {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 16px;
    &-item {
		.daysStat-item();
        &_active {
            color: #374b62;
            background: #0fd7b7;
            border: none;
        }
    }
}

.lastMonths {
    display: flex;
    align-items: center;
    &-item {
        color:#adc4e1;
        border-radius: 4px;
        border: 1px solid #adc4e1;
        font-size: 13px;
        font-family: Arimo;
        padding: 4px;
        margin-left: 8px;
        &-active {
            color:#374b62;
            background: #0fd7b7;
            border:none;
        }
    }
}

.chart__inf-wrap {
    padding: 12px 12px 12px 12px;
    display: flex;
    justify-content: space-between;
    z-index: 1;
    position: absolute;
}

.returnToDate {
    font-size:11px;
    color: #374b62;
    font-family: Arimo;
    cursor: pointer;
    padding: 4px;
    background: #0fd7b7;
    border-radius: 4px;
    margin-right: 8px;
    display: flex;
    align-items: center;
}

</style>
